export enum LoyaltyTransactionTypeLabelEnum {
  ADJUSTMENT = 'Affecté',
  EARNED = 'Points gagnés',
  REDEEMED = 'Points utilisés',
}
